import * as React from 'react'

import { F0Select } from '@factorialco/f0-react'

import { observer } from 'mobx-react'

import FormRow from 'modules/core/components/FormRow'
import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import i18n from 'modules/core/lib/i18n'

import type ReportsForm from 'modules/employees/lib/forms/Reports'
import leaveTypes from 'modules/timeoff/store/collections/leaveTypes'

interface Props {
  form: ReportsForm
}

const ExportLeaveSelector = ({ form }: Props) => {
  useAsyncData(async () => {
    await leaveTypes.fetch()
  }, [])
  const visibleLeaveTypes = leaveTypes.active

  const options = React.useMemo(() => {
    return visibleLeaveTypes.map((leaveType) => ({
      label: leaveType.name,
      value: String(leaveType.attributes.id),
    }))
  }, [visibleLeaveTypes])

  const leaveTypeIdsValue = form.get('leave_type_ids').value

  const selectedValues = React.useMemo(() => {
    if (!Array.isArray(leaveTypeIdsValue)) {
      return []
    }
    return leaveTypeIdsValue.map((id: string) => String(id))
  }, [leaveTypeIdsValue])

  const handleChange = (selection: string[]) => {
    const ids = selection
    form.setValues({
      leave_type_ids: ids,
    })
  }

  return (
    <>
      <FormRow>
        <F0Select
          multiple
          size="sm"
          label={i18n.t('employees.reports.select_absence_types')}
          placeholder={i18n.t('leave_type_selector.label.zero')}
          searchBoxPlaceholder={i18n.t('common.search')}
          options={options}
          value={selectedValues}
          onChange={handleChange}
          showSearchBox
        />
      </FormRow>
    </>
  )
}

export default observer(ExportLeaveSelector)
